import React, { useState, useEffect } from 'react';
import './UserPagesOptimized.css';
import { Table, Button, Tag, message, Modal, Image, Space, Card, Input } from 'antd';
import './UserPagesOptimized.css';
import { EyeOutlined, CloseOutlined, SwapOutlined } from '@ant-design/icons';
import './UserPagesOptimized.css';
import { registrationAPI } from '../../services/api';
import './UserPagesOptimized.css';
import { MyRegistration } from '../../types';
import './UserPagesOptimized.css';
import dayjs from 'dayjs';
import './UserPagesOptimized.css';
import { useAuth } from '../../context/AuthContext';
import './UserPagesOptimized.css';

const MyRegistrations: React.FC = () => {
  const [registrations, setRegistrations] = useState<MyRegistration[]>([]);
  const [loading, setLoading] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentQrUrl, setPaymentQrUrl] = useState('');
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [selectedRegistration, setSelectedRegistration] = useState<MyRegistration | null>(null);
  const [withdrawReason, setWithdrawReason] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    const loadRegistrations = async () => {
      if (!user) return;
      
      setLoading(true);
      try {
        const data = await registrationAPI.getMyRegistrations();
        setRegistrations(data);
      } catch (error) {
        message.error('获取报名记录失败');
      } finally {
        setLoading(false);
      }
    };
    
    loadRegistrations();
  }, [user]);

  const fetchRegistrations = async () => {
    if (!user) return;
    
    setLoading(true);
    try {
      const data = await registrationAPI.getMyRegistrations();
      setRegistrations(data);
    } catch (error) {
      message.error('获取报名记录失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelRegistration = async (record: MyRegistration) => {
    try {
      await registrationAPI.cancelRegistration(record.id);
      message.success('取消报名成功');
      fetchRegistrations();
    } catch (error: any) {
      message.error(error.response?.data?.message || '取消报名失败');
    }
  };

  const handleShowPayment = (qrUrl: string) => {
    setPaymentQrUrl(qrUrl);
    setShowPaymentModal(true);
  };

  const handleWithdraw = async () => {
    if (!selectedRegistration || !withdrawReason.trim()) {
      message.warning('请填写退课原因');
      return;
    }

    try {
      await registrationAPI.withdrawCourse(selectedRegistration.courseId, withdrawReason);
      message.success('退课申请已提交，请等待审核');
      setShowWithdrawModal(false);
      setWithdrawReason('');
      fetchRegistrations();
    } catch (error: any) {
      message.error(error.response?.data?.message || '退课申请失败');
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'paid': return 'green';
      case 'refunded': return 'red';
      default: return 'default';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'paid': return '已付款';
      case 'refunded': return '已退款';
      default: return status;
    }
  };

  const getPaymentStatusColor = (status: string) => {
    switch (status) {
      case 'paid': return 'green';
      case 'refunded': return 'red';
      default: return 'default';
    }
  };

  const getPaymentStatusText = (status: string) => {
    switch (status) {
      case 'paid': return '已支付';
      case 'refunded': return '已退款';
      default: return status;
    }
  };

  const columns = [
    {
      title: '课程信息',
      key: 'course',
      render: (_: any, record: MyRegistration) => (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
            {record.courseName}
          </div>
          <div style={{ color: '#666', fontSize: '12px' }}>
            地点: {record.location}
          </div>
          <div style={{ color: '#666', fontSize: '12px' }}>
            时间: {dayjs(record.startDate).format('YYYY-MM-DD HH:mm')}
          </div>
          {record.teacherName && (
            <div style={{ color: '#666', fontSize: '12px' }}>
              老师: {record.teacherName}
            </div>
          )}
        </div>
      ),
    },
    {
      title: '报名状态',
      dataIndex: 'status',
      render: (status: string) => (
        <Tag color={getStatusColor(status)}>
          {getStatusText(status)}
        </Tag>
      ),
    },
    {
      title: '支付状态',
      dataIndex: 'paymentStatus',
      render: (status: string, record: MyRegistration) => (
        <div>
          <Tag color={getPaymentStatusColor(status)}>
            {getPaymentStatusText(status)}
          </Tag>
          {status === 'pending' && (
            <Button
              type="link"
              size="small"
              onClick={() => record.paymentQrUrl && handleShowPayment(record.paymentQrUrl)}
            >
              查看支付码
            </Button>
          )}
        </div>
      ),
    },
    {
      title: '报名时间',
      dataIndex: 'registrationTime',
      render: (time: string) => dayjs(time).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: '操作',
      key: 'actions',
      render: (_: any, record: MyRegistration) => {
        const canOperate = record.status !== 'refunded';
        const isBeforeStart = dayjs(record.startDate).isAfter(dayjs());

        return (
          <Space>
            {record.paymentQrUrl && record.paymentStatus !== 'refunded' && (
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => record.paymentQrUrl && handleShowPayment(record.paymentQrUrl)}
              >
                支付信息
              </Button>
            )}
            
            {canOperate && isBeforeStart && (
              <>
                <Button
                  type="link"
                  danger
                  icon={<CloseOutlined />}
                  onClick={() => {
                    setSelectedRegistration(record);
                    setShowWithdrawModal(true);
                  }}
                >
                  退课
                </Button>
                
                <Button
                  type="link"
                  icon={<SwapOutlined />}
                  onClick={() => {
                    // TODO: 实现课程变更功能
                    message.info('课程变更功能开发中');
                  }}
                >
                  换课
                </Button>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <Card>
        <h1 style={{ marginBottom: '24px' }}>我的报名记录</h1>
        
        <Table
          columns={columns}
          dataSource={registrations}
          loading={loading}
          rowKey="id"
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条记录`,
          }}
        />
      </Card>

      {/* 支付二维码弹窗 */}
      <Modal
        title="支付课程费用"
        visible={showPaymentModal}
        onCancel={() => setShowPaymentModal(false)}
        footer={[
          <Button key="close" onClick={() => setShowPaymentModal(false)}>
            关闭
          </Button>,
        ]}
      >
        <div style={{ textAlign: 'center' }}>
          <h3>请使用支付宝扫码支付</h3>
          {paymentQrUrl && (
            <Image
              src={paymentQrUrl}
              alt="支付宝支付二维码"
              style={{ width: '200px', height: '200px', margin: '20px auto' }}
            />
          )}
          <p style={{ color: '#666', fontSize: '14px' }}>
            支付成功后，您的报名将自动确认
          </p>
        </div>
      </Modal>

      {/* 退课申请弹窗 */}
      <Modal
        title="申请退课"
        visible={showWithdrawModal}
        onCancel={() => {
          setShowWithdrawModal(false);
          setWithdrawReason('');
        }}
        onOk={handleWithdraw}
        okText="提交申请"
        cancelText="取消"
      >
        <div>
          <p>您确定要申请退课吗？</p>
          {selectedRegistration && (
            <div style={{ marginBottom: 16 }}>
              <strong>课程：</strong>{selectedRegistration.courseName}<br />
              <strong>时间：</strong>{dayjs(selectedRegistration.startDate).format('YYYY-MM-DD HH:mm')}
            </div>
          )}
          <Input.TextArea
            rows={4}
            placeholder="请填写退课原因..."
            value={withdrawReason}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setWithdrawReason(e.target.value)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default MyRegistrations;